import pb from '../lib/pocketbase';

export const EmailService = {
    // Send transactional email via PocketBase Mailer (if configured server-side with custom function)
    // Or create a record in a 'mailable' collection that triggers a hook.
    // For standard PB setup, we often rely on client-side triggers or a small backend function.
    // Assuming here we use a 'messages' collection or similar to trigger server-side logic:

    async sendInvoiceCreated(invoice, client) {
        try {
            console.log(`Simulating email to ${client.email}: Invoice ${invoice.reference} created.`);
            // In a real scenario, you'd call a cloud function here
            // await pb.send('/api/custom/email/invoice', { invoiceId: invoice.id });
        } catch (err) {
            console.error("Failed to send invoice email", err);
        }
    },

    async sendNewApplication(application) {
        try {
            console.log(`Simulating admin notification: New application from ${application.firstname} ${application.lastname}`);
            // await pb.admins.requestpasswordReset(...) or custom endpoint
        } catch (err) {
            console.error("Failed to send admin notification", err);
        }
    },

    async sendWelcome(user) {
        try {
            console.log(`Simulating welcome email to ${user.email}`);
        } catch (err) {
            console.error("Failed to send welcome email", err);
        }
    }
};
